import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import styles from "./SellerUpdate.module.css";
import { Link, useParams } from "react-router-dom";
import Popup from "../Popup/Popup";
import Spinner from "../Spinner/Spinner";
import { API } from "../../config";
import { useNavigate } from "react-router-dom";
import { useImageUpload } from "../ClientLogos/hooks/useImageUpload";

function SellerUpdate() {
  const [name, setName] = useState();
  const [logo, setLogo] = useState();
  const [client, setClient] = useState([]);
  const [spin, setSpin] = useState(true);
  const [spinn, setSpinn] = useState(false);
  let navigate = useNavigate();
  const [show, setShow] = useState(false);
  const fileInputRef = useRef(null);
  const {
    selectedFile,
    imagePreview,
    uploadError,
    setUploadError,
    handleFileChange,
    uploadImage,
    resetImageState,
  } = useImageUpload();

  const params = useParams();

  const change = () => {
    setShow(false);
  };

  const getData = async () => {
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title: "Fetch PUT Request Example" }),
    };
    const response = await fetch(
      `${API}/brandLogo/${params.id}`,
      requestOptions
    );
    const data = await response.json();
    setClient(data);
    setSpin(false);
    setLogo(data.logo_url);
    setName(data.brand_name);
  };

  useEffect(() => {
    getData();
  }, []);

  const deleteData = () => {
    axios.delete(`${API}/brandLogo/${params.id}`);
    navigate("/sellerlogos");
  };

  const saveData = async (event) => {
    event.preventDefault();
    setUploadError("");

    // Validate required fields
    if (!name) {
      setUploadError("Brand name is required");
      return;
    }

    window.scrollTo(0, 0);
    setSpinn(true);

    try {
      let imageUrl = logo;

      if (selectedFile) {
        const uploadedImageUrl = await uploadImage(selectedFile);
        if (!uploadedImageUrl) {
          setUploadError("Failed to upload image. Please try again.");
          setSpinn(false);
          return;
        }
        imageUrl = uploadedImageUrl;
      }

      const data = {
        brand_name: name,
        logo_url: imageUrl,
      };

      await axios.put(`${API}/brandLogo/${params.id}`, data);
      setShow(true);
      setSpinn(false);
      resetImageState();
      navigate(-1);
    } catch (err) {
      console.error(err);
      setUploadError(
        err.response?.data?.message ||
          "Failed to update seller logo. Please try again."
      );
      setSpinn(false);
    }
  };

  // console.log(client);

  return (
    <>
      {spinn ? <Spinner /> : null}
      {show ? (
        <Popup show={show} switch={change} message="Updated Successfully" />
      ) : null}
      {spin ? (
        <Spinner />
      ) : (
        <div className={styles.clientpage}>
          <div className={styles.heading}>
            <h1 className={styles.details}>Update/Delete Seller Logo</h1>
            <form onSubmit={saveData}>
              <div className={styles.items}>
                <div className={styles.second}>
                  <p>Enter the Brand Name</p>
                  <input
                    name="brand_name"
                    placeholder="Brand Name"
                    type="text"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    id={styles.gap}
                    required
                  ></input>
                </div>

                <div className={styles.images}>
                  <input
                    ref={fileInputRef}
                    name="logo_file"
                    type="file"
                    accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                    onChange={handleFileChange}
                    id={styles.file}
                    style={{ display: "none" }}
                  />
                  {!selectedFile ? (
                    logo && (
                      <div style={{ marginTop: "12px", marginBottom: "12px" }}>
                        <p style={{ marginBottom: "8px" }}>Current Logo:</p>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <img
                            src={logo}
                            alt="Current Logo"
                            className={styles.imglogo}
                          ></img>
                          <button
                            type="button"
                            onClick={() => fileInputRef.current?.click()}
                            className={styles.bttn}
                            style={{
                              padding: "8px 16px",
                              fontSize: "16px",
                            }}
                          >
                            Change
                          </button>
                        </div>
                      </div>
                    )
                  ) : (
                    <div>
                      <p>New Logo Preview:</p>
                      {uploadError && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            marginTop: "8px",
                            marginBottom: "8px",
                          }}
                        >
                          {uploadError}
                        </div>
                      )}
                      {imagePreview && (
                        <div style={{ marginTop: "12px" }}>
                          <img
                            src={imagePreview}
                            alt="Preview"
                            style={{
                              maxWidth: "200px",
                              maxHeight: "200px",
                              borderRadius: "8px",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>
                      )}
                      <button
                        type="button"
                        onClick={() => {
                          resetImageState();
                          if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                          }
                        }}
                        className={styles.bttn}
                        style={{
                          padding: "8px 16px",
                          fontSize: "16px",
                          marginTop: "12px",
                          backgroundColor: "#ccc",
                          color: "#000",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                  <p
                    style={{
                      fontSize: "14px",
                      fontStyle: "italic",
                    }}
                  >
                    Supported file types: JPEG, PNG, WebP
                  </p>
                </div>

                <div className={styles.button}>
                  <input
                    type="submit"
                    className={styles.bttn}
                    style={{ marginRight: "24px" }}
                    value="Update"
                  />
                  <input
                    type="reset"
                    className={styles.bttn}
                    onClick={deleteData}
                    value="Delete"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default SellerUpdate;
